export const blockIconsUiactionsToggleOnNew = (
	<span className='material-symbols-outlined'>toggle_on</span>
);
